export default {
    formatList(response) {
        if(typeof response == 'undefined') {
            return null;
        }

        return {
            hadeeths: response.data,
            meta: {
                current_page: response.meta.current_page,
                last_page: response.meta.last_page,
            }
        };
    },

    formatSingleHadeeth(response) {

        if(typeof response == 'undefined') {
            return null;
        }

        return response;
    },

    formatSearchResults(response) {
        if(typeof response == 'undefined') {
            return [];
        }

        return response;
    },
}